import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { CREW_INFO, getItemFromSessionStorage } from 'src/app/utils/SessionStorageUtil';
import { ExternalCrewInfo } from 'src/app/models/ExternalCrewInfo';
import { MyFlightsComponent } from 'src/app/flight/my-flights/my-flights.component';
import { Router } from '@angular/router';
import { AccessRestrictionDialogService } from 'src/app/shared/services/access-restriction-dialog.service';
@Component({
  selector: 'app-external-home',
  templateUrl: './external-home.component.html',
  standalone: false
})
export class ExternalHomeComponent implements OnInit {

  crewInfo: ExternalCrewInfo | null;

  selectedIndex: number;

  constructor(
    private dialog: MatDialog,
    private accessRestrictionDialogService: AccessRestrictionDialogService,
    private router: Router) { }

  ngOnInit(): void {
    this.selectTab();
    this.refresh();

    this.crewInfo = getItemFromSessionStorage<ExternalCrewInfo>(CREW_INFO);

    if (this.crewInfo) {
      console.log('[external-home] crewInfo loaded from session', {
        firstAccess: this.crewInfo.firstAccess,
        hasAccess: this.crewInfo.hasAccess,
        email: this.crewInfo.email,
        company: this.crewInfo.company,
        companyDomain: this.crewInfo.companyDomain
      });

      // Note: MFA and first access validation are now handled in /external-validation route
      // The guard redirects to /external-validation if validation is pending

      if (this.crewInfo.blocked || !this.crewInfo.hasAccess) {
        this.openNoAccessDialog();
      } else {
        // User has completed all validations - load content
        if (MyFlightsComponent.instance) {
          MyFlightsComponent.instance.getTickets();
        }
      }
    }
  }

  private selectTab(): void {
    const tab = this.extractDataFromUrl('tab');

    if (tab) {
      const tabNumber = Number(tab);
      this.selectedIndex = tabNumber;
    } else {
      this.selectedIndex = 0;
    }
  }

  private refresh(): void {
    const refresh = this.extractDataFromUrl('refresh');

    if (refresh && MyFlightsComponent.instance) {
      MyFlightsComponent.instance.refreshTickets();
    }
  }

  private extractDataFromUrl(param: string): string | undefined {
    const url = this.router.url;
    const match = url.match(RegExp(`${param}=(.+)`));

    if (match && match[1]) {
      return match[1];
    }

    return undefined;
  }

  private shouldOpenFirstAccessDialog(crewInfo: ExternalCrewInfo): boolean {
    return crewInfo.firstAccess;
  }

  openFirstAcessDialog(): void {
    this.dialog.open(ChangePasswordComponent, {
      width: '775px',
      maxWidth: 'calc(100vw - 24px)',
      maxHeight: 'calc(100vh - 24px)',
      autoFocus: false,
      disableClose: true,
      closeOnNavigation: false,
      data: {
        crew: this.crewInfo,
        mode: 'first-access'
      }
    });
  }

  openMfaDialog(): void {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '775px',
      maxWidth: 'calc(100vw - 24px)',
      maxHeight: 'calc(100vh - 24px)',
      autoFocus: false,
      disableClose: true,
      closeOnNavigation: false,
      data: {
        crew: this.crewInfo,
        mode: 'mfa'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.mfaVerified && this.crewInfo) {
        this.crewInfo.requiresMfa = false;
        if (MyFlightsComponent.instance) {
          MyFlightsComponent.instance.getTickets();
        }
      }
    });
  }

  openNoAccessDialog(): void {
    this.accessRestrictionDialogService.open({
      active: this.crewInfo?.hasAccess,
      valid: true,
      blocked: this.crewInfo?.blocked,
      accessDeniedMessage: this.crewInfo?.accessDeniedMessage
    });
  }

}
